import { Expose } from 'class-transformer';

export class CartProductOptionModel {
  @Expose({ name: 'option_id' })
  optionId: number;

  @Expose({ name: 'option_name' })
  optionName: string;

  @Expose()
  quantity: number;

  price: number;
}
